export default {
  "b2b.projekty-grid.add": "Add project",
  "b2b.projekty-grid.title": "Projects",
  "b2b.projekty-grid.delete-dialog.title": "Delete Project",
  "b2b.projekty-grid.delete-dialog.confirm":
    "Are you sure you want to delete this project?"
};
